import React, { useState } from 'react';
import "../../assets/css/hospitals/hospitals.css";
import { FileValidationIcon } from 'hugeicons-react';
import toast from 'react-hot-toast';
import { PrimaryButton, SecondaryButton } from '../forms/buttons';
import { TextInput } from '../forms/Input';
import api, { API_URL } from '../../api';

const AddHospitalListPopup = ({ onClose, onAddHospital }) => {
  const [hospitalName, setHospitalName] = useState('');
  const [hospitalAddress, setHospitalAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [ccnNumber, setCcnNumber] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formError, setFormError] = useState('');
  const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!hospitalName.trim()) {
      tempErrors.hospitalName = "Hospital Name is required";
      isValid = false;
    } else if (/\d/.test(hospitalName)) {
      tempErrors.hospitalName = "Hospital Name should not contain numbers";
      isValid = false;
    }

    if (!hospitalAddress.trim()) {
      tempErrors.hospitalAddress = "Hospital Address is required";
      isValid = false;
    }

    if (!phoneNumber.trim()) {
      tempErrors.phoneNumber = "Phone Number is required";
      isValid = false;
    } else if (!/^\d+$/.test(phoneNumber)) {
      tempErrors.phoneNumber = "Phone Number should contain only numbers";
      isValid = false;
    }

    if (!ccnNumber.trim()) {
      tempErrors.ccnNumber = "CCN is required";
      isValid = false;
    } else if (!/^\d+$/.test(ccnNumber)) {
      tempErrors.ccnNumber = "CCN should contain only numbers";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validate()) {
      return;
    }

    if (isSubmitting) return;
    setIsSubmitting(true);
    setFormError('');

    try {
      const newHospital = {
        name: hospitalName.trim(),
        address: hospitalAddress.trim(),
        phone_number: phoneNumber.trim(),
        ccn_number: ccnNumber.trim()
      };

      setIsLoading(true);
      const response = await api.post(`${API_URL}/hospitals/new_hospital/`, newHospital);

      if (response.status === 200 || response.status === 201) {
        if (onAddHospital) {
          onAddHospital(response.data);
        }

        toast.success("Hospital successfully added");

        setTimeout(() => {
          onClose();
          if (!onAddHospital) {
            window.location.reload();
          }
        }, 1500);

      } else {
        toast.error("Failed to add Hospital");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error.response) {
        const detail = error.response.data.detail || error.response.data.message || JSON.stringify(error.response.data);
        setFormError('Error: ' + detail);
        toast.error('Error: ' + detail);
      } else {
        setFormError('Something went wrong. Please try again');
        toast.error('Something went wrong. Please try again');
      }
    } finally {
      setIsLoading(false);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="popup-overlayer">
      <div className="popup-content">
        <div className="form-container">
          <h2>Add New Hospital</h2>
          {formError && <div className="form-error-message" style={{ color: 'red', marginBottom: '10px' }}>{formError}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="hospitalName">Hospital Name <span style={{ color: "red" }}>*</span></label>
              <TextInput
                type="text"
                name="hospitalName"
                placeholder="Hospital Name"
                value={hospitalName}
                setValue={setHospitalName}
              />
              {errors.hospitalName && <span style={{ color: 'red', fontSize: '12px' }}>{errors.hospitalName}</span>}
            </div>

            <div className='form-group'>
              <label htmlFor="hospitalAddress">Hospital Address <span style={{ color: "red" }}>*</span></label>
              <TextInput
                type="text"
                name="hospitalAddress"
                placeholder="Hospital Address"
                value={hospitalAddress}
                setValue={setHospitalAddress}
              />
              {errors.hospitalAddress && <span style={{ color: 'red', fontSize: '12px' }}>{errors.hospitalAddress}</span>}
            </div>
            <div className='form-group'>
              <label htmlFor="phoneNumber">Phone Number <span style={{ color: "red" }}>*</span></label>
              <TextInput
                type="tel"
                name="phoneNumber"
                placeholder="Phone Number"
                value={phoneNumber}
                setValue={setPhoneNumber}
              />
              {errors.phoneNumber && <span style={{ color: 'red', fontSize: '12px' }}>{errors.phoneNumber}</span>}
            </div>
            <div className='form-group'>
              <label htmlFor="ccnNumber">CMS Certification Number (CCN) <span style={{ color: "red" }}>*</span></label>
              <TextInput
                type="text"
                name="ccnNumber"
                placeholder="CMS Certification Number (CCN)"
                value={ccnNumber}
                setValue={setCcnNumber}
              />
              {errors.ccnNumber && <span style={{ color: 'red', fontSize: '12px' }}>{errors.ccnNumber}</span>}
            </div>


            <div className='buttons'>
              <PrimaryButton
                isLoading={isSubmitting}
                onClick={handleSubmit}
                type='button'
                processingText='Submitting'
                buttonText='Save'
              // disabled={isSubmitting} 
              />
              <SecondaryButton
                onClick={onClose}
                buttonText='Cancel'
                type="button"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddHospitalListPopup;
